import { render, staticRenderFns } from "./BatchTransfer.vue?vue&type=template&id=e6280ed6&scoped=true&"
import script from "./BatchTransfer.vue?vue&type=script&lang=js&"
export * from "./BatchTransfer.vue?vue&type=script&lang=js&"
import style0 from "./BatchTransfer.vue?vue&type=style&index=0&id=e6280ed6&lang=less&scoped=true&"
import style1 from "./BatchTransfer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6280ed6",
  null
  
)

export default component.exports